import $ from "jquery";

export let plannerIsRemovingDevices = false;
export let IS_READ_ONLY_USER = false;

export let DEBUG=false;

export const supportedCurrencies = ['eur', 'huf', 'gbp', 'czk', 'usd', 'pln', 'chf'];

/**
 *
 * @template T
 * @param {T} obj
 * @returns {T}
 */
export function deepCopy(obj) {
  var src = Array.isArray(obj) ? [] : {};
  return $.extend(true, src, obj);
}

export function getTextFromHtmlString(htmlStr) {
  return $('<span>' + htmlStr + '</span>').text().trim();
}

export function clearStringOfQuoteIDs(string) {
  return string?.replace(/\(\#(LOXONE_PROGRAMMING_ROW|SERVICE_FEE_ROW)\#\)/g,
      '');
}

export function dlInlineSVG_HTML(url, color) {
  let inlineSvg = null;
  $.get({
    url: url,
    cache: true,
    async: false,
    success: function (resp) {
      let parsed = $(resp);
      let svg = parsed.filter("svg").add(parsed.find("svg"));
      if (!svg.length) {
        return;
      }
      svg.find("path").attr("fill", color);
      inlineSvg = svg[0].outerHTML;
    }
  });
  return inlineSvg;
}

export function getFileDate() {
  var date = new Date();
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  var hour = date.getHours();
  var minute = date.getMinutes();

  day = addLeadingZero(day);
  month = addLeadingZero(month);
  hour = addLeadingZero(hour);
  minute = addLeadingZero(minute);

  return year + "-" + month + "-" + day + " " + hour + "-" + minute;
}

function addLeadingZero(time) {
  if (time < 10) {
    time = '0' + time;
  }
  return time;
}



export function toastInfoSingle(text, sticky = false, withClass = "") {
}

export function toastSuccess() {
}

export function toastError(text, sticky = false, withClass = "") {
}


